import { render, staticRenderFns } from "./CoinAmount.vue?vue&type=template&id=5ec4f730&scoped=true"
import script from "./CoinAmount.vue?vue&type=script&lang=ts"
export * from "./CoinAmount.vue?vue&type=script&lang=ts"
import style0 from "./CoinAmount.vue?vue&type=style&index=0&id=5ec4f730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4f730",
  null
  
)

export default component.exports